import styled from 'styled-components';

export const VideoCap = styled.div`
  background: #30353b;
  &.offline1 {
    background: #111214;
  }
`;

export const TwoVideosPlace = styled.div`
  display: block;
  position: relative;
`;
